const RightsEnum = Object.freeze({
  Write: 0,
  Setting: 1,
  Public: 2,
  Person: 3,
  Account: 4,
})

export default RightsEnum

/*
export default class RightsEnum {
  static Write = new RightsEnum(0)
  static Setting = new RightsEnum(1)
  static Public = new RightsEnum(2)
  static Person = new RightsEnum(3)
  static Account = new RightsEnum(4)

  constructor(right) {
    this.right = right
  }
}
*/
